import React, { useEffect, useState } from "react";

import auth from "../../../services/authService";

import BlogService from "../../../services/blogService";
import { paginate } from "../../../utils/paginate";
import { useParams } from "react-router-dom";
import BlogShortPosts from "./common/blogShortPosts";

const Blog = () => {
  const [user, setUser] = useState({});
  const [blog, setBlog] = useState([]);
  const [category, setCategory] = useState([]);
  const [popularBlog, setPopularBlog] = useState([]);
  const [selectedGenre, setSelectedGenre] = useState(null);
  const [searchQuery, setSearchQuery] = useState("");
  let { postId } = useParams();

  useEffect(() => {
    let user = auth.getCurrentUser();
    setUser(user);
    let blog = BlogService.getBlogData(1);
    setBlog(blog);
    let popularBlog = BlogService.getBlog();
    setPopularBlog(popularBlog);
    let category = BlogService.getBlogCategory();
    setCategory(category);
  }, [postId]);

  return (
    <div className="container-fluid">
      <div className="row pt-2 rgba-white-light" style={{ height: "400px" }}>
        <img
          src={blog.imageUrl}
          alt=""
          style={{ height: "inherit" }}
          width="100%"
        />
      </div>

      <div className="row" style={{ marginTop: "-120px" }}>
        <div className="col-md-12 px-lg-4">
          <div className="card pb-5 mx-md-3">
            <div className="card-body">
              <div className="container-fluid">
                <h1 class="text-center h1 pt-4 mb-3">
                  <strong>{blog.title}</strong>
                </h1>
                <div class="row">
                  <div class="col-md-12 col-xl-12 d-flex justify-content-center">
                    <p class="font-small dark-grey-text mb-1">
                      <strong>Author:</strong> {blog.author}
                    </p>
                    <p class="font-small grey-text mb-0 ml-3">
                      <i class="far fa-clock dark-grey-text"></i> 15/09/2017 at
                      4:03 pm
                    </p>
                  </div>
                  <div className="row pt-lg-5 pt-3">
                    <div className="col-lg-9 px-4">
                      <div class="mt-3">
                        <p class="dark-grey-text article">
                          Lorem ipsum dolor sit amet, consectetur adipiscing
                          elit, sed do eiusmod tempor incididunt ut labore et
                          dolore magna aliqua. Ut enim ad minim veniam, quis
                          nostrud exercitation ullamco laboris nisi ut aliquip
                          ex ea commodo consequat. Duis aute irure dolor in
                          reprehenderit in voluptate velit esse cillum dolore eu
                          fugiat nulla pariatur. Excepteur sint occaecat
                          cupidatat non proident, sunt in culpa qui officia
                          deserunt mollit anim id est laborum.
                        </p>

                        <h4 class="font-weight-bold mt-3 mb-4">
                          <strong>Lorem ipsum dolor sit amet</strong>
                        </h4>

                        <p class="dark-grey-text article">
                          Sed ut perspiciatis unde omnis iste natus error sit
                          voluptatem accusantium doloremque laudantium, totam
                          rem aperiam, eaque ipsa quae ab illo inventore
                          veritatis et quasi architecto beatae vitae dicta sunt
                          explicabo. Nemo enim ipsam voluptatem quia voluptas
                          sit aspernatur aut odit aut fugit, sed quia
                          consequuntur magni dolores eos qui ratione voluptatem
                          sequi nesciunt. Neque porro quisquam est, qui dolorem
                          ipsum quia dolor sit amet, consectetur, adipisci
                          velit, sed quia non numquam eius modi tempora incidunt
                          ut labore et dolore magnam aliquam quaerat voluptatem.{" "}
                        </p>

                        <blockquote class="blockquote">
                          <p class="mb-0">
                            Lorem ipsum dolor sit amet, consectetur adipiscing
                            elit. Integer posuere erat a ante.
                          </p>
                          <footer class="blockquote-footer">
                            Someone famous in
                            <cite title="Source Title">Source Title</cite>
                          </footer>
                        </blockquote>

                        <p class="dark-grey-text article">
                          Ut enim ad minima veniam, quis nostrum exercitationem
                          ullam corporis suscipit laboriosam, nisi ut aliquid ex
                          ea commodi consequatur? Quis autem vel eum iure
                          reprehenderit qui in ea voluptate velit esse quam
                          nihil molestiae consequatur, vel illum qui dolorem eum
                          fugiat quo voluptas nulla pariatur.
                        </p>
                        <p class="dark-grey-text article">
                          Perspiciatis unde omnis iste natus error sit
                          voluptatem accusantium doloremque laudantium, totam
                          rem aperiam, eaque ipsa quae ab illo inventore
                          veritatis et quasi architecto beatae vitae dicta sunt
                          explicabo. Ut enim ad minima veniam, quis nostrum
                          exercitationem ullam corporis suscipit laboriosam,
                          nisi ut aliquid ex ea commodi consequatur? Quis autem
                          vel eum iure reprehenderit qui in ea voluptate velit
                          esse quam nihil molestiae consequatur, vel illum qui
                          dolorem eum fugiat quo voluptas nulla.
                        </p>

                        <li class="dark-grey-text article list-unstyled">
                          <strong>Nulla volutpat aliquam velit:</strong>
                          <ul>
                            <li>Phasellus iaculis neque</li>
                            <li>Purus sodales ultricies</li>
                            <li>Vestibulum laoreet porttitor sem</li>
                            <li>Ac tristique libero volutpat at</li>
                            <li>Vestibulum laoreet porttitor sem</li>
                          </ul>
                        </li>

                        <p class="dark-grey-text article">
                          Sed ut perspiciatis unde omnis iste natus error sit
                          voluptatem accusantium doloremque laudantium, totam
                          rem aperiam, eaque ipsa quae ab illo inventore
                          veritatis et quasi architecto beatae vitae dicta sunt
                          explicabo. Nemo enim ipsam voluptatem quia voluptas
                          sit aspernatur ut perspiciatis unde omnis iste natus
                          error sit voluptatem accusantium doloremque
                          laudantium, totam rem aperiam, eaque ipsa quae ab illo
                          inventore veritatis et quasi architecto beatae vitae
                          dicta sunt explicabo. Nemo enim ipsam voluptatem quia
                          voluptas sit aspernatur aut odit aut fugit, sed quia
                          consequuntur magni dolores eos qui ratione voluptatem
                          sequi nesciunt. Neque porro quisquam est, qui dolorem
                          ipsum quia dolor sit amet, consectetur, adipisci
                          velit, sed quia non numquam eius modi tempora incidunt
                          ut labore et dolore magnam aliquam quaerat voluptatem.
                        </p>
                        <div class="row my-5">
                          <div class="col-md-12 text-center">
                            <hr class="my-3" />

                            <h4 class="text-center font-weight-bold dark-grey-text mt-3 mb-3">
                              <strong>Share this post: </strong>
                            </h4>
                            <hr class="my-3" />

                            {/* <button type="button" class="btn btn-fb btn-sm">
                              <i class="fab fa-facebook-f left"></i> Facebook
                            </button>
                            <button type="button" class="btn btn-tw btn-sm">
                              <i class="fab fa-twitter left"></i> Twitter
                            </button>
                            <button type="button" class="btn btn-gplus btn-sm">
                              <i class="fab fa-google-plus-g left"></i> Google +
                            </button> */}
                          </div>
                        </div>
                      </div>
                    </div>
                    <div className="col-lg-3 px-2">
                      <div>
                        <div>
                          <img
                            src="https://mdbootstrap.com/img/Photos/Others/images/20.jpg"
                            class="card-img-top"
                            alt=""
                          />
                        </div>

                        <div class="card-body">
                          <h5 class="card-title dark-grey-text text-center grey lighten-4 py-2">
                            <strong>Anna Doe</strong>
                          </h5>

                          <p class="mt-3 dark-grey-text font-small text-center">
                            <em>
                              Hello, I'm Anna. I love travel around the world
                              and take photos of landscapes and local people.
                            </em>
                          </p>

                          <ul class="list-unstyled list-inline-item circle-icons list-unstyled flex-center">
                            <li>
                              <a class="fb-ic">
                                <i class="fab fa-facebook-f"> </i>
                              </a>
                            </li>
                            <li>
                              <a class="tw-ic">
                                <i class="fab fa-twitter mx-3"> </i>
                              </a>
                            </li>
                            <li>
                              <a class="gplus-ic">
                                <i class="fab fa-google-plus-g"> </i>
                              </a>
                            </li>
                          </ul>
                        </div>
                      </div>
                      {}
                      <div>
                        <h5 class="font-weight-bold">
                          <strong>FEATURED POSTS</strong>
                        </h5>

                        <hr class="red" />
                        <BlogShortPosts posts={popularBlog}></BlogShortPosts>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default Blog;
